module.exports = __webpack_public_path__ + "static/media/mag.7e464a01.png";